import type { DbManagerKeyspace } from "../../../api/dbManager.service.js";
import {
  type SearchIndexDescription,
  describeSearchIndex,
  searchIndexReasonsId,
} from "./searchIndexStatus.js";
import styles from "./DbManager.module.css";

function SearchIndexValue({
  description,
  reasonsId,
}: {
  description: SearchIndexDescription;
  reasonsId: string;
}) {
  if (description.kind === "unknown") return <>unknown</>;
  if (description.kind === "ready") return <>{description.summary}</>;
  return (
    <span className={styles.searchIndexNotReady} data-testid="search-index-not-ready">
      {description.summary}
      <span id={reasonsId} className={styles.searchIndexReasons}>
        Not ready: {description.reasons.join("; ")}
      </span>
    </span>
  );
}

export function SearchIndexLine({ entry }: { entry: DbManagerKeyspace }) {
  const description = describeSearchIndex(entry);
  if (!description) return null;
  return (
    <span className={styles.searchIndexLine}>
      Search index:{" "}
      <SearchIndexValue description={description} reasonsId={searchIndexReasonsId(entry)} />
    </span>
  );
}

export function SearchIndexMetadata({ entry }: { entry: DbManagerKeyspace }) {
  const description = describeSearchIndex(entry);
  if (!description) return null;
  return (
    <div>
      <dt>Search index</dt>
      <dd>
        <SearchIndexValue description={description} reasonsId={searchIndexReasonsId(entry)} />
      </dd>
    </div>
  );
}
